import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import socialShareTwStyles from './socialShare-tw-styles';
import i18nMessages from '../../../constants/messages/pt-BR';

/**
 * Whatsapp share button will only show for Smartphone
 */

class SocialShare extends Component {
  constructor(props) {
    super(props);
    this.state = {
      socialShareUrl: '',
      dataAction: null,
    };
  }
  componentDidMount() {
    const {
      type,
      subject: text,
      shareDescription,
      shareImage,
    } = this.props; /**Reffer to the Prop types bellow */
    switch (type) {
      case i18nMessages.facebook:
        this.setState({
          socialShareUrl: `https://www.facebook.com/sharer.php?u=${window.location.href}`,
          dataAction: 'share/facebook/share',
        });
        break;
      case i18nMessages.instagram:
        this.setState({
          socialShareUrl: `https://www.instagram.com/?url=${window.location.href}`,
          dataAction: 'share/Instagram/share',
        });
        break;
      case i18nMessages.pinterest:
        this.setState({
          socialShareUrl: `https://in.pinterest.com/pin/create/button/?url=${window.location.href}&media=${shareImage}&description=${shareDescription}`,
          dataAction: 'share/Pinterest/share',
        });
        break;

      case i18nMessages.twitter:
        this.setState({
          socialShareUrl: `https://twitter.com/intent/tweet?url=${window.location.href}`,
          dataAction: 'share/twitter/share',
        });
        break;

      case i18nMessages.whatsApp:
        this.setState({
          socialShareUrl: `whatsapp://send?text=${text}%0A%0A${window.location.href}`,
          dataAction: 'share/whatsapp/share',
        });
        break;
      default:
        break;
    }
  }

  render() {
    const { socialShareUrl, dataAction } = this.state;
    const { children, title, closeNavDialog, ariaLabel, className } = this.props;
    
    const handleClick = (e) => {
      e.preventDefault();
      if (closeNavDialog) {
        closeNavDialog();
      }
      // Open the share URL in a new window
      if (socialShareUrl) {
        window.open(socialShareUrl, '_blank', 'noopener,noreferrer');
      }
    };
    
    const handleKeyDown = (e) => {
      // Allow Enter and Space to activate the link
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        handleClick(e);
      }
    };

    return (
      <Fragment>
        <div
          className={classNames(socialShareTwStyles.socialConnectIcons.button)}
        >
          <a
            data-pgaction-redirection="0"
            title={title}
            data-action-detail={dataAction}
            className={classNames(
              socialShareTwStyles.socailLink,
              'event_share',
              className
            )}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            href={socialShareUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={ariaLabel || title}
            tabIndex={0}
          >
            {children}
          </a>
        </div>
      </Fragment>
    );
  }
}

SocialShare.propTypes = {
  type: PropTypes.string,
  subject: PropTypes.string,
  shareImage: PropTypes.string,
  shareDescription: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node,
  closeNavDialog: PropTypes.func,
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
};

SocialShare.defaultProps = {
  closeNavDialog: () => null,
  type: 'Facebook',
  subject: '',
  title: '',
  children: null,
  shareImage: '',
  shareDescription: '',
  ariaLabel: '',
  className: '',
};

export default SocialShare;
